// extracted by mini-css-extract-plugin
module.exports = {"button":"C_bz","outline":"C_bB","secondary":"C_bC"};